var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanningicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_20080)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_20080)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5417 40.623C21.8771 40.623 21.3082 40.3864 20.8349 39.9131C20.3616 39.4399 20.125 38.871 20.125 38.2064V21.2897C20.125 20.6251 20.3616 20.0562 20.8349 19.5829C21.3082 19.1097 21.8771 18.873 22.5417 18.873H34.625L41.875 26.123V38.2064C41.875 38.871 41.6384 39.4399 41.1651 39.9131C40.6918 40.3864 40.1229 40.623 39.4583 40.623H22.5417ZM24.9583 35.7897H37.0417V33.373H24.9583V35.7897ZM24.9583 30.9564H37.0417V28.5397H24.9583V30.9564ZM24.9583 26.123H33.4167V23.7064H24.9583V26.123Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_20080",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_20080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_20080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_20080",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningicon);
export default __webpack_public_path__ + "static/media/planning+icon.914cfba586fe8ca574106328285e8a0e.svg";
export { ForwardRef as ReactComponent };